import React, { Component } from "react";
import { Col, Row } from "react-bootstrap";
import { Field, Form, Formik } from "formik";
import * as FormConfirmationMessages from "pages/forms/_components/_confirmations/Index";
import Message from "pages/forms/_components/_fields/_scheduler/Message";
import Button from "pages/_components/Button";
import Credential from "pages/_components/fields/credentials/Credential";
import I18n from "pages/_components/I18n";
import { arrayOf, func, shape, string } from "prop-types";
import { connect } from "react-redux";
import { selectors as formSelectors } from "reducers/form";
import { compose } from "redux";
import { flattenArray, removeDuplicateItems } from "util/array";
import * as i18n from "util/i18n";
import * as Yup from "yup";

class FormConfirmation extends Component {
    static propTypes = {
        idForm: string.isRequired,
        credentials: arrayOf(string).isRequired,
        dispatch: func.isRequired,
        submitAction: func.isRequired,
        submitActionParams: shape({
            idActivity: string.isRequired,
            values: shape({
                scheduler: string,
            }),
        }).isRequired,
        currentLang: string.isRequired,
        metadata: shape({}).isRequired,
        renderFields: func.isRequired,
        renderFieldsTermsAndConditions: func,
    };

    static defaultProps = {
        renderFieldsTermsAndConditions: null,
    };

    validationSchema = () => {
        const { credentials } = this.props;
        return Yup.object().shape(
            credentials.reduce(
                (values, credential) => ({
                    ...values,
                    [credential]: Yup.string().required(i18n.get(`form.credential.${credential}.required`)),
                }),
                {},
            ),
        );
    };

    handleSubmit = (credentials, formikBag) => {
        const { dispatch, submitAction, submitActionParams } = this.props;
        dispatch(submitAction({ ...submitActionParams, credentials, formikBag }));
    };

    renderDefaultConfirmation = () => {
        const { renderFields } = this.props;
        return (
            <>
                <p className="text-lead">
                    <I18n id="forms.transferInternal.confirmation.title" />
                </p>
                <div className="form-confirmation-content-fields">{renderFields()}</div>
            </>
        );
    };

    render() {
        const {
            credentials,
            idForm,
            submitActionParams: {
                idActivity,
                values: { scheduler },
            },
            currentLang,
            metadata,
            renderFieldsTermsAndConditions,
        } = this.props;

        let FormConfirmationMessage;
        if (idForm !== null) {
            FormConfirmationMessage =
                FormConfirmationMessages[(idForm.charAt(0).toUpperCase() + idForm.substr(1)).replace(".", "_")];
        }
        const requireSomeCredential = credentials.length > 0;
        let dynamicKey = i18n.generateFieldForm("button", idActivity, "confirm");
        if (!i18n.getI18Component("button", currentLang, idActivity, "confirm")) {
            dynamicKey = "global.send";
        }

        return (
            <Row className="form-confirmation-container">
                <Col xs={12} md={8} mdOffset={2} lg={6} lgOffset={3}>
                    <div>
                        {FormConfirmationMessage ? (
                            <FormConfirmationMessage metadata={metadata} currentLang={currentLang} />
                        ) : (
                            this.renderDefaultConfirmation(requireSomeCredential)
                        )}

                        {scheduler && (
                            <div className="data-wrapper">
                                <span className="data-label">
                                    <I18n id="forms.confirmation.scheduler" />
                                </span>
                                <span className="data-text">
                                    <Message value={scheduler} />
                                </span>
                            </div>
                        )}
                    </div>

                    <Formik
                        validateOnBlur={false}
                        validateOnChange={false}
                        initialValues={credentials.reduce(
                            (values, credential) => ({ ...values, [credential]: "" }),
                            {},
                        )}
                        validationSchema={this.validationSchema}
                        onSubmit={this.handleSubmit}>
                        {({ isSubmitting }) => (
                            <Form>
                                <Row className="form-confirmation-confirm">
                                    <span>
                                        {i18n.get("form.confirmation.without.credential")}{" "}
                                        {<b>{i18n.get(dynamicKey)}</b>}
                                    </span>
                                    <Col sm={12} lg={6} className="col-12">
                                        {renderFieldsTermsAndConditions ? renderFieldsTermsAndConditions() : ""}
                                        {credentials.map((credential) => (
                                            <Field
                                                idForm="form.credential"
                                                name={credential}
                                                component={Credential}
                                                type={credential}
                                            />
                                        ))}
                                    </Col>
                                    <Col sm={12} lg={6} className="col-12 mb-lg-4 d-flex align-items-end">
                                        <Button
                                            block
                                            type="submit"
                                            label={dynamicKey}
                                            bsStyle="primary"
                                            loading={isSubmitting}
                                        />
                                    </Col>
                                </Row>
                            </Form>
                        )}
                    </Formik>
                </Col>
            </Row>
        );
    }
}

const mapStateToProps = (state) => ({
    name: formSelectors.getName(state),
    metadata: formSelectors.getMetadata(state),
    submitAction: formSelectors.getSubmitAction(state),
    submitActionParams: formSelectors.getSubmitActionParams(state),
    credentials: compose(
        (array) => array.filter((item) => item !== "accessToken"),
        removeDuplicateItems,
        flattenArray,
        (array) => array.map(({ credentials }) => credentials),
    )(formSelectors.getCredentialsGroups(state)),
});

export default connect(mapStateToProps)(FormConfirmation);
